// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournamentGridModern {
  min-height: 100vh;
  margin-top: -20px;
  background: #f5f7fa;
  color: #334155;
}

.tournamentGridModern svg {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.9;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.tournamentGridModern__pageHeader {
  margin: 0 -24px;
  padding: 15px 28px 16px;
  border-bottom: 1px solid #dfe5ec;
  background: #fff;
}

.tournamentGridModern__back {
  display: inline-flex;
  height: 30px;
  align-items: center;
  gap: 5px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #227ebd;
  font-size: 12.5px;
  font-weight: 700;
}

.tournamentGridModern__back svg {
  width: 17px;
  height: 17px;
}

.tournamentGridModern__pageHeader h1 {
  margin: 3px 0 0;
  color: #142033;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.tournamentGridModern__headerMain {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px 24px;
  margin-top: 8px;
}

.tournamentGridModern__headerMain > div:first-child {
  min-width: 0;
  flex: 1 1 360px;
}

.tournamentGridModern__headerMain > div:first-child > span {
  color: #267cab;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .09em;
  text-transform: uppercase;
}

.tournamentGridModern__summary {
  display: flex;
  max-width: 100%;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 7px;
}

.tournamentGridModern__summary > span {
  display: inline-flex;
  min-height: 27px;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11.5px;
  font-weight: 650;
  white-space: nowrap;
}

.tournamentGridModern__summary strong {
  color: #0f172a;
  font-weight: 800;
}

.tournamentGridModern__summary > span.is-warning {
  border-color: #ffe9c2;
  background: #fff6e6;
  color: #a85c07;
}

.tournamentGridModern__summary > span.is-warning strong {
  margin-right: 5px;
  color: inherit;
}

.tournamentGridModern__pageHeader > p {
  margin: 5px 0 0;
  color: #69778a;
  font-size: 12.5px;
}

.tournamentGridModern__workspace {
  width: 100%;
  max-width: none;
  padding: 6px 4px 40px;
}

.tournamentGridModern__card {
  overflow: hidden;
  border: 1px solid #dfe5ec;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.tournamentGridModern__noGroups {
  display: flex;
  min-height: 280px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 32px;
  text-align: center;
}

.tournamentGridModern__noGroups > svg {
  width: 30px;
  height: 30px;
  color: #8a98aa;
}

.tournamentGridModern__noGroups h2 {
  margin: 4px 0 0;
  color: #243247;
  font-size: 16px;
}

.tournamentGridModern__noGroups p {
  margin: 0;
  color: #748195;
  font-size: 12.5px;
}

.tournamentGridModern__noGroups button {
  height: 36px;
  margin-top: 7px;
  padding: 0 14px;
  border: 1px solid #227ebd;
  border-radius: 8px;
  background: #227ebd;
  color: #fff;
  font-size: 12.5px;
  font-weight: 700;
}

.tournamentGridModern__cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 15px 18px;
  border-bottom: 1px solid #e6ebf0;
}

.tournamentGridModern__cardTools {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.tournamentGridModern__cardTitleTools {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 12px;
}

.tournamentGridModern__search {
  display: flex;
  width: 260px;
  height: 38px;
  min-width: 210px;
  align-items: center;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.tournamentGridModern__search:focus-within {
  border-color: #227ebd;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);
}

.tournamentGridModern__search input {
  width: 100%;
  min-width: 0;
  height: 100%;
  padding: 0 10px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #334155;
  font-size: 13px;
}

.tournamentGridModern__search button {
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  align-items: center;
  justify-content: center;
  margin-right: 3px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  font-size: 18px;
  line-height: 1;
}

.tournamentGridModern__search button:hover {
  background: #f1f5f9;
  color: #334155;
}

.tournamentGridModern__groupControl {
  display: grid;
  width: min(430px, 46vw);
  min-width: 300px;
  align-items: center;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 8px;
  margin: 0;
}

.tournamentGridModern__groupControl > span {
  color: #64748b;
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.045em;
  text-transform: uppercase;
}

.tournamentGridModern__cardHeader h2,
.tournamentGridModern__panel h3 {
  margin: 0;
  color: #1e2d41;
  font-size: 14.5px;
  font-weight: 750;
}

.tournamentGridModern__cardHeader p,
.tournamentGridModern__panel header p {
  margin: 4px 0 0;
  color: #748195;
  font-size: 11.5px;
  line-height: 1.4;
}

.tournamentGridModern__unsaved {
  display: inline-flex;
  min-height: 25px;
  align-items: center;
  padding: 0 9px;
  border-radius: 999px;
  background: #fff4d9;
  color: #95620d;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
}

.tournamentGridModern__controls {
  display: flex;
  align-items: flex-end;
  gap: 14px;
  padding: 14px 18px;
  border-bottom: 1px solid #e6ebf0;
  background: #f8fafc;
}

.tournamentGridModern__placeFilter > span {
  display: block;
  margin-bottom: 6px;
  color: #64748b;
  font-size: 10.5px;
  font-weight: 750;
  letter-spacing: 0.045em;
  text-transform: uppercase;
}

.tournamentGridModern__placeChips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tournamentGridModern__placeChips button {
  min-width: 42px;
  height: 30px;
  padding: 0 11px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.tournamentGridModern__placeChips button:hover {
  border-color: #8dbbd7;
  background: #eef6fc;
  color: #155d8c;
}

.tournamentGridModern__placeChips button.is-active {
  border-color: #227ebd;
  background: #227ebd;
  color: #fff;
}

.tournamentGridModern__select {
  appearance: none;
  width: 100%;
  min-height: 38px;
  padding: 0 38px 0 12px;
  border: 1px solid #cbd5e1 !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E") !important;
  background-repeat: no-repeat !important;
  background-position: right 11px center !important;
  color: #334155 !important;
  font-size: 13px !important;
  font-weight: 600;
  outline: none;
  cursor: pointer;
}

.tournamentGridModern__select:hover {
  border-color: #9fb5c8 !important;
}

.tournamentGridModern__select:focus {
  border-color: #227ebd !important;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);
}

.tournamentGridModern__panels {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 52px minmax(0, 1fr);
  gap: 0;
  padding: 18px;
}

.tournamentGridModern__panel {
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dfe5ec;
  border-radius: 12px;
  background: #fff;
}

.tournamentGridModern__panel > header {
  display: flex;
  min-height: 63px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 11px 14px;
  border-bottom: 1px solid #e6ebf0;
  background: #f8fafc;
}

.tournamentGridModern__panel > header > div {
  min-width: 0;
}

.tournamentGridModern__panel > header p {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.tournamentGridModern__panel > header > span {
  display: inline-flex;
  min-width: 25px;
  height: 25px;
  align-items: center;
  justify-content: center;
  padding: 0 7px;
  border-radius: 999px;
  background: #eaf4fb;
  color: #176b9d;
  font-size: 11.5px;
  font-weight: 750;
}

.tournamentGridModern__teamList {
  min-height: 320px;
  max-height: calc(100vh - 430px);
  overflow-y: auto;
  padding: 10px;
  background: #fbfcfd;
}

.tournamentGridModern__direction {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #227ebd;
}

.tournamentGridModern__direction svg {
  width: 24px;
  height: 24px;
}

.eTeamDropSection {
  min-height: 0;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;
}

.eTeamDropSection.is-over {
  border-color: #227ebd;
  background: #eef7fc;
  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);
}

.eTeamCard {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  padding: 9px 10px;
  border: 1px solid #dfe5ec;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  cursor: grab;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease;
}

.eTeamCard:last-child {
  margin-bottom: 0;
}

.eTeamCard:hover {
  border-color: #b7c8d8;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.eTeamCard.is-dragging {
  opacity: 0.45;
}

.eTeamCardSchoolPicWrapper,
.eTeamCardSchoolPicWrapper img,
.eTeamCardSchoolPicWrapper > span {
  display: inline-flex;
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
}

.eTeamCardSchoolPicWrapper img {
  padding: 2px;
  background: #fff;
  object-fit: contain;
}

.eTeamCardSchoolPicWrapper > span {
  background: #eaf4fb;
  color: #176b9d;
  font-size: 12px;
  font-weight: 800;
}

.eTeamCardTeamName {
  display: flex;
  min-width: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
}

.eTeamCardTeamName strong,
.eTeamCardTeamName span,
.eTeamCardTeamName small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.eTeamCardTeamName strong {
  color: #243247;
  font-size: 12.5px;
  font-weight: 750;
}

.eTeamCardTeamName span,
.eTeamCardTeamName small {
  color: #748195;
  font-size: 11px;
}

.eTeamCardAreas {
  display: flex;
  min-width: 0;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 2px;
}

.eTeamCardTeamName .eTeamCardAreas > span {
  display: inline-flex;
  max-width: 145px;
  align-items: center;
  padding: 2px 6px;
  overflow: hidden;
  border: 1px solid #cfe3f1;
  border-radius: 999px;
  background: #eef6fc;
  color: #155d8c;
  font-size: 9.5px;
  font-weight: 700;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.eTeamCardDrag {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  color: #9aa5b3;
}

.eTeamCardOrder {
  display: grid;
  grid-template-columns: 24px 22px 24px;
  align-items: center;
  gap: 2px;
  padding: 2px;
  border: 1px solid #e1e7ed;
  border-radius: 8px;
  background: #f8fafc;
}

.eTeamCardOrder span {
  color: #526276;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
}

.eTeamCardOrder button {
  display: grid;
  width: 24px;
  height: 24px;
  padding: 0;
  place-items: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #607991;
  font-size: 9px;
}

.eTeamCardOrder button:hover:not(:disabled) {
  background: #eaf4fb;
  color: #176b9d;
}

.eTeamCardOrder button:disabled {
  color: #c4ccd4;
  cursor: not-allowed;
}

.tournamentGridModern__panel > header small {
  display: block;
  margin-top: 3px;
  color: #7d8b9b;
  font-size: 10px;
  font-weight: 400;
}

.eTeamCardTeamAction {
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #9b3d46;
  font-size: 19px;
  line-height: 1;
}

.eTeamCardTeamAction:hover {
  background: #fff0f1;
  color: #b4232f;
}

.tournamentGridModern__emptyDrop,
.tournamentGridModern__emptyList {
  display: flex;
  min-height: 180px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 6px;
  padding: 22px;
  color: #748195;
  font-size: 12px;
  text-align: center;
}

.tournamentGridModern__emptyDrop {
  border: 1px dashed #b9cad9;
  border-radius: 10px;
  background: #f8fbfd;
}

.tournamentGridModern__emptyDrop svg {
  width: 24px;
  height: 24px;
  color: #227ebd;
}

.tournamentGridModern__emptyDrop strong {
  color: #334155;
  font-size: 12.5px;
}

.tournamentGridModern__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
  padding: 13px 18px;
  border-top: 1px solid #e6ebf0;
  background: #f8fafc;
}

.tournamentGridModern__footer button {
  min-width: 104px;
  height: 38px;
  padding: 0 15px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 750;
}

.tournamentGridModern__footer button.is-secondary {
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
}

.tournamentGridModern__footer button.is-primary {
  border: 1px solid #227ebd;
  background: #227ebd;
  color: #fff;
}

.tournamentGridModern__footer button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

@media (max-width: 760px) {
  .tournamentGridModern__pageHeader,
  .tournamentGridModern__workspace {
    padding-right: 16px;
    padding-left: 16px;
  }

  .tournamentGridModern__controls {
    align-items: stretch;
    flex-direction: column;
  }

  .tournamentGridModern__cardHeader,
  .tournamentGridModern__cardTools,
  .tournamentGridModern__cardTitleTools {
    align-items: stretch;
    flex-direction: column;
  }

  .tournamentGridModern__groupControl {
    width: 100%;
    min-width: 0;
    grid-template-columns: 1fr;
  }

  .tournamentGridModern__search {
    width: 100%;
  }

  .tournamentGridModern__panels {
    grid-template-columns: minmax(0, 1fr);
    gap: 10px;
  }

  .tournamentGridModern__direction {
    transform: rotate(90deg);
  }

  .tournamentGridModern__teamList {
    max-height: 360px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminSUView/Tournaments/TournamentGrid/TournamentGrid.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,6BAA6B;EAC7B,iCAAiC;EACjC,mRAAmR;EACnR,uCAAuC;EACvC,iDAAiD;EACjD,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;EAChB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,MAAM;EACN,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uFAAuF;AACzF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;EACZ,8EAA8E;AAChF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,QAAQ;AACV;;AAEA;;;EAGE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;;IAEE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".tournamentGridModern {\n  min-height: 100vh;\n  margin-top: -20px;\n  background: #f5f7fa;\n  color: #334155;\n}\n\n.tournamentGridModern svg {\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.9;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.tournamentGridModern__pageHeader {\n  margin: 0 -24px;\n  padding: 15px 28px 16px;\n  border-bottom: 1px solid #dfe5ec;\n  background: #fff;\n}\n\n.tournamentGridModern__back {\n  display: inline-flex;\n  height: 30px;\n  align-items: center;\n  gap: 5px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #227ebd;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.tournamentGridModern__back svg {\n  width: 17px;\n  height: 17px;\n}\n\n.tournamentGridModern__pageHeader h1 {\n  margin: 3px 0 0;\n  color: #142033;\n  font-size: 22px;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.tournamentGridModern__headerMain {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 14px 24px;\n  margin-top: 8px;\n}\n\n.tournamentGridModern__headerMain > div:first-child {\n  min-width: 0;\n  flex: 1 1 360px;\n}\n\n.tournamentGridModern__headerMain > div:first-child > span {\n  color: #267cab;\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: .09em;\n  text-transform: uppercase;\n}\n\n.tournamentGridModern__summary {\n  display: flex;\n  max-width: 100%;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.tournamentGridModern__summary > span {\n  display: inline-flex;\n  min-height: 27px;\n  align-items: center;\n  padding: 0 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 11.5px;\n  font-weight: 650;\n  white-space: nowrap;\n}\n\n.tournamentGridModern__summary strong {\n  color: #0f172a;\n  font-weight: 800;\n}\n\n.tournamentGridModern__summary > span.is-warning {\n  border-color: #ffe9c2;\n  background: #fff6e6;\n  color: #a85c07;\n}\n\n.tournamentGridModern__summary > span.is-warning strong {\n  margin-right: 5px;\n  color: inherit;\n}\n\n.tournamentGridModern__pageHeader > p {\n  margin: 5px 0 0;\n  color: #69778a;\n  font-size: 12.5px;\n}\n\n.tournamentGridModern__workspace {\n  width: 100%;\n  max-width: none;\n  padding: 6px 4px 40px;\n}\n\n.tournamentGridModern__card {\n  overflow: hidden;\n  border: 1px solid #dfe5ec;\n  border-radius: 13px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.tournamentGridModern__noGroups {\n  display: flex;\n  min-height: 280px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 8px;\n  padding: 32px;\n  text-align: center;\n}\n\n.tournamentGridModern__noGroups > svg {\n  width: 30px;\n  height: 30px;\n  color: #8a98aa;\n}\n\n.tournamentGridModern__noGroups h2 {\n  margin: 4px 0 0;\n  color: #243247;\n  font-size: 16px;\n}\n\n.tournamentGridModern__noGroups p {\n  margin: 0;\n  color: #748195;\n  font-size: 12.5px;\n}\n\n.tournamentGridModern__noGroups button {\n  height: 36px;\n  margin-top: 7px;\n  padding: 0 14px;\n  border: 1px solid #227ebd;\n  border-radius: 8px;\n  background: #227ebd;\n  color: #fff;\n  font-size: 12.5px;\n  font-weight: 700;\n}\n\n.tournamentGridModern__cardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 15px 18px;\n  border-bottom: 1px solid #e6ebf0;\n}\n\n.tournamentGridModern__cardTools {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.tournamentGridModern__cardTitleTools {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 12px;\n}\n\n.tournamentGridModern__search {\n  display: flex;\n  width: 260px;\n  height: 38px;\n  min-width: 210px;\n  align-items: center;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #fff;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.tournamentGridModern__search:focus-within {\n  border-color: #227ebd;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.12);\n}\n\n.tournamentGridModern__search input {\n  width: 100%;\n  min-width: 0;\n  height: 100%;\n  padding: 0 10px;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #334155;\n  font-size: 13px;\n}\n\n.tournamentGridModern__search button {\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  flex: 0 0 30px;\n  align-items: center;\n  justify-content: center;\n  margin-right: 3px;\n  padding: 0;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #64748b;\n  font-size: 18px;\n  line-height: 1;\n}\n\n.tournamentGridModern__search button:hover {\n  background: #f1f5f9;\n  color: #334155;\n}\n\n.tournamentGridModern__groupControl {\n  display: grid;\n  width: min(430px, 46vw);\n  min-width: 300px;\n  align-items: center;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 8px;\n  margin: 0;\n}\n\n.tournamentGridModern__groupControl > span {\n  color: #64748b;\n  font-size: 10.5px;\n  font-weight: 750;\n  letter-spacing: 0.045em;\n  text-transform: uppercase;\n}\n\n.tournamentGridModern__cardHeader h2,\n.tournamentGridModern__panel h3 {\n  margin: 0;\n  color: #1e2d41;\n  font-size: 14.5px;\n  font-weight: 750;\n}\n\n.tournamentGridModern__cardHeader p,\n.tournamentGridModern__panel header p {\n  margin: 4px 0 0;\n  color: #748195;\n  font-size: 11.5px;\n  line-height: 1.4;\n}\n\n.tournamentGridModern__unsaved {\n  display: inline-flex;\n  min-height: 25px;\n  align-items: center;\n  padding: 0 9px;\n  border-radius: 999px;\n  background: #fff4d9;\n  color: #95620d;\n  font-size: 11px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.tournamentGridModern__controls {\n  display: flex;\n  align-items: flex-end;\n  gap: 14px;\n  padding: 14px 18px;\n  border-bottom: 1px solid #e6ebf0;\n  background: #f8fafc;\n}\n\n.tournamentGridModern__placeFilter > span {\n  display: block;\n  margin-bottom: 6px;\n  color: #64748b;\n  font-size: 10.5px;\n  font-weight: 750;\n  letter-spacing: 0.045em;\n  text-transform: uppercase;\n}\n\n.tournamentGridModern__placeChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.tournamentGridModern__placeChips button {\n  min-width: 42px;\n  height: 30px;\n  padding: 0 11px;\n  border: 1px solid #cbd5e1;\n  border-radius: 999px;\n  background: #fff;\n  color: #64748b;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.tournamentGridModern__placeChips button:hover {\n  border-color: #8dbbd7;\n  background: #eef6fc;\n  color: #155d8c;\n}\n\n.tournamentGridModern__placeChips button.is-active {\n  border-color: #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.tournamentGridModern__select {\n  appearance: none;\n  width: 100%;\n  min-height: 38px;\n  padding: 0 38px 0 12px;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 8px !important;\n  background-color: #fff !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 11px center !important;\n  color: #334155 !important;\n  font-size: 13px !important;\n  font-weight: 600;\n  outline: none;\n  cursor: pointer;\n}\n\n.tournamentGridModern__select:hover {\n  border-color: #9fb5c8 !important;\n}\n\n.tournamentGridModern__select:focus {\n  border-color: #227ebd !important;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.16);\n}\n\n.tournamentGridModern__panels {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 52px minmax(0, 1fr);\n  gap: 0;\n  padding: 18px;\n}\n\n.tournamentGridModern__panel {\n  min-width: 0;\n  overflow: hidden;\n  border: 1px solid #dfe5ec;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.tournamentGridModern__panel > header {\n  display: flex;\n  min-height: 63px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 11px 14px;\n  border-bottom: 1px solid #e6ebf0;\n  background: #f8fafc;\n}\n\n.tournamentGridModern__panel > header > div {\n  min-width: 0;\n}\n\n.tournamentGridModern__panel > header p {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.tournamentGridModern__panel > header > span {\n  display: inline-flex;\n  min-width: 25px;\n  height: 25px;\n  align-items: center;\n  justify-content: center;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: #eaf4fb;\n  color: #176b9d;\n  font-size: 11.5px;\n  font-weight: 750;\n}\n\n.tournamentGridModern__teamList {\n  min-height: 320px;\n  max-height: calc(100vh - 430px);\n  overflow-y: auto;\n  padding: 10px;\n  background: #fbfcfd;\n}\n\n.tournamentGridModern__direction {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #227ebd;\n}\n\n.tournamentGridModern__direction svg {\n  width: 24px;\n  height: 24px;\n}\n\n.eTeamDropSection {\n  min-height: 0;\n  transition: border-color 0.16s ease, box-shadow 0.16s ease, background-color 0.16s ease;\n}\n\n.eTeamDropSection.is-over {\n  border-color: #227ebd;\n  background: #eef7fc;\n  box-shadow: 0 0 0 3px rgba(34, 126, 189, 0.14);\n}\n\n.eTeamCard {\n  display: flex;\n  min-width: 0;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 8px;\n  padding: 9px 10px;\n  border: 1px solid #dfe5ec;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);\n  cursor: grab;\n  transition: border-color 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease;\n}\n\n.eTeamCard:last-child {\n  margin-bottom: 0;\n}\n\n.eTeamCard:hover {\n  border-color: #b7c8d8;\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);\n}\n\n.eTeamCard.is-dragging {\n  opacity: 0.45;\n}\n\n.eTeamCardSchoolPicWrapper,\n.eTeamCardSchoolPicWrapper img,\n.eTeamCardSchoolPicWrapper > span {\n  display: inline-flex;\n  width: 34px;\n  height: 34px;\n  flex: 0 0 34px;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  border-radius: 50%;\n}\n\n.eTeamCardSchoolPicWrapper img {\n  padding: 2px;\n  background: #fff;\n  object-fit: contain;\n}\n\n.eTeamCardSchoolPicWrapper > span {\n  background: #eaf4fb;\n  color: #176b9d;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.eTeamCardTeamName {\n  display: flex;\n  min-width: 0;\n  flex: 1 1 auto;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.eTeamCardTeamName strong,\n.eTeamCardTeamName span,\n.eTeamCardTeamName small {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.eTeamCardTeamName strong {\n  color: #243247;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.eTeamCardTeamName span,\n.eTeamCardTeamName small {\n  color: #748195;\n  font-size: 11px;\n}\n\n.eTeamCardAreas {\n  display: flex;\n  min-width: 0;\n  flex-wrap: wrap;\n  gap: 4px;\n  margin-top: 2px;\n}\n\n.eTeamCardTeamName .eTeamCardAreas > span {\n  display: inline-flex;\n  max-width: 145px;\n  align-items: center;\n  padding: 2px 6px;\n  overflow: hidden;\n  border: 1px solid #cfe3f1;\n  border-radius: 999px;\n  background: #eef6fc;\n  color: #155d8c;\n  font-size: 9.5px;\n  font-weight: 700;\n  line-height: 1.2;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.eTeamCardDrag {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 18px;\n  color: #9aa5b3;\n}\n\n.eTeamCardOrder {\n  display: grid;\n  grid-template-columns: 24px 22px 24px;\n  align-items: center;\n  gap: 2px;\n  padding: 2px;\n  border: 1px solid #e1e7ed;\n  border-radius: 8px;\n  background: #f8fafc;\n}\n\n.eTeamCardOrder span {\n  color: #526276;\n  font-size: 10px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.eTeamCardOrder button {\n  display: grid;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  place-items: center;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: #607991;\n  font-size: 9px;\n}\n\n.eTeamCardOrder button:hover:not(:disabled) {\n  background: #eaf4fb;\n  color: #176b9d;\n}\n\n.eTeamCardOrder button:disabled {\n  color: #c4ccd4;\n  cursor: not-allowed;\n}\n\n.tournamentGridModern__panel > header small {\n  display: block;\n  margin-top: 3px;\n  color: #7d8b9b;\n  font-size: 10px;\n  font-weight: 400;\n}\n\n.eTeamCardTeamAction {\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: #9b3d46;\n  font-size: 19px;\n  line-height: 1;\n}\n\n.eTeamCardTeamAction:hover {\n  background: #fff0f1;\n  color: #b4232f;\n}\n\n.tournamentGridModern__emptyDrop,\n.tournamentGridModern__emptyList {\n  display: flex;\n  min-height: 180px;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 6px;\n  padding: 22px;\n  color: #748195;\n  font-size: 12px;\n  text-align: center;\n}\n\n.tournamentGridModern__emptyDrop {\n  border: 1px dashed #b9cad9;\n  border-radius: 10px;\n  background: #f8fbfd;\n}\n\n.tournamentGridModern__emptyDrop svg {\n  width: 24px;\n  height: 24px;\n  color: #227ebd;\n}\n\n.tournamentGridModern__emptyDrop strong {\n  color: #334155;\n  font-size: 12.5px;\n}\n\n.tournamentGridModern__footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 9px;\n  padding: 13px 18px;\n  border-top: 1px solid #e6ebf0;\n  background: #f8fafc;\n}\n\n.tournamentGridModern__footer button {\n  min-width: 104px;\n  height: 38px;\n  padding: 0 15px;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 750;\n}\n\n.tournamentGridModern__footer button.is-secondary {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  color: #334155;\n}\n\n.tournamentGridModern__footer button.is-primary {\n  border: 1px solid #227ebd;\n  background: #227ebd;\n  color: #fff;\n}\n\n.tournamentGridModern__footer button:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n@media (max-width: 760px) {\n  .tournamentGridModern__pageHeader,\n  .tournamentGridModern__workspace {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n\n  .tournamentGridModern__controls {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .tournamentGridModern__cardHeader,\n  .tournamentGridModern__cardTools,\n  .tournamentGridModern__cardTitleTools {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .tournamentGridModern__groupControl {\n    width: 100%;\n    min-width: 0;\n    grid-template-columns: 1fr;\n  }\n\n  .tournamentGridModern__search {\n    width: 100%;\n  }\n\n  .tournamentGridModern__panels {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 10px;\n  }\n\n  .tournamentGridModern__direction {\n    transform: rotate(90deg);\n  }\n\n  .tournamentGridModern__teamList {\n    max-height: 360px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
